export enum SortDirectionEnum {
  DEFAULT = 0,
  ASCENDING = 1,
  DESCENDING = -1,
}
